import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=5738fd0a&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports